export const VersionManager = {
  run: async () => {
    const APP_VERSION = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : 'dev';
    const storedVersion = localStorage.getItem('rda_app_version');

    if (storedVersion !== APP_VERSION) {
      console.warn(`🚀 [RDA UPDATE] Nova versão ${APP_VERSION}. Otimizando...`);

      try {
        // 1. Matar Service Workers (aguardar)
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((r) => r.unregister()));
        }

        // 2. Limpar Cache Storage (aguardar)
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      } catch (e) {
        console.warn('[RDA UPDATE] Falha ao limpar SW/cache:', e);
      }

      // 3. Atualizar flag e recarregar com cache-bust (força baixar chunks novos)
      localStorage.setItem('rda_app_version', APP_VERSION);
      if (import.meta.env.PROD && storedVersion) {
        const url = new URL(window.location.href);
        url.searchParams.set('v', APP_VERSION);
        window.location.replace(url.toString());
      }
    } else {
      console.log(`✅ RDA System v${APP_VERSION} Stable.`);
    }
  }
};